import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import CorrespondencesTypesListView from "./correspondences_types-list.html";
import CorrespondencesTypesEditView from "./correspondences_types-edit.html";


angular.module("correspondences_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('correspondences_types', {
                url: "/correspondences_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('correspondences_types.list', {
                url: "/list",
                controller: "CorrespondencesTypesListCtrl",
                template: CorrespondencesTypesListView,
                requiredPermission: ["CORRESPONDENCE_TYPE_READ"]
            })             
            .state('correspondences_types.edit', {
                url: "/edit/:id",
                controller: "CorrespondencesTypesEditCtrl",
                template: CorrespondencesTypesEditView,
                requiredPermission: ["CORRESPONDENCE_TYPE_READ"]
            })
    }])
;